module.exports = __webpack_public_path__ + "static/media/bottom-banner.3fa4ae22.jpg";